export default __webpack_public_path__ + "static/media/Back-End-Illustration.08a95427.svg";